/* eslint-disable react/prop-types */
import gql from "graphql-tag"
import { useMutation } from "@apollo/client"
import { withProps } from "recompose"
import { CASE_DETAIL_FRAGMENT, CASE_LIST } from "./queries"

export const PUT_CASE = gql`
  mutation ContactTracingPutCase(
    $facilityId: ID!
    $type: ContactTracingCaseTypeEnum!
    $subjects: [ContactTracingSubjectAttributes!]!
    $id: ID
    $delete: Boolean
    $archive: Boolean
  ) {
    putContactTracingCase(
      facilityId: $facilityId
      type: $type
      subjects: $subjects
      id: $id
      delete: $delete
      archive: $archive
    ) {
      ...caseDetailFragment
    }
  }
  ${CASE_DETAIL_FRAGMENT}
`

export const archiveCaseMutation = withProps((props) => {
  const [archiveCase, { loading, error, data }] = useMutation(
    gql`
      mutation ContactTracingArchiveCase(
        $id: ID!
        $type: ContactTracingCaseTypeEnum!
        $facilityId: ID!
        $subjects: [ContactTracingSubjectAttributes!]!
        $archive: Boolean!
      ) {
        putContactTracingCase(
          id: $id
          type: $type
          facilityId: $facilityId
          subjects: $subjects
          archive: $archive
        ) {
          id
          archivedAt
        }
      }
    `,
    // The empty function supplied for the onError callback is designed to
    // resolve the error itself returned from the onSubmit Promise. This allows
    // us to pass errors out to components as props but to ensure that the
    // Promise can resolve successfully first.
    // For more information: https://stackoverflow.com/a/59472340
    {
      onError: () => {},
      refetchQueries: [
        {
          query: CASE_LIST,
          variables: {
            facilityId: props.facilityId,
            archived: true,
          },
        },
        {
          query: CASE_LIST,
          variables: {
            facilityId: props.facilityId,
            archived: false,
          },
        },
      ],
      awaitRefetchQueries: true,
    }
  )

  const onArchive = ({
    id,
    type,
    facilityId,
    subjects,
    archive,
    timeout = 0,
  }) => {
    setTimeout(() => {
      archiveCase({
        variables: {
          id,
          type,
          facilityId,
          subjects,
          archive,
        },
      })
    }, timeout)
  }

  if (error) throw error

  return { onArchive, archiveLoading: loading, archiveData: data }
})

export const deleteCaseMutation = withProps((props) => {
  const [deleteCase, { loading, error }] = useMutation(
    gql`
      mutation ContactTracingDeleteCase(
        $id: ID!
        $type: ContactTracingCaseTypeEnum!
        $facilityId: ID!
        $subjects: [ContactTracingSubjectAttributes!]!
        $deleted: Boolean!
      ) {
        putContactTracingCase(
          id: $id
          type: $type
          facilityId: $facilityId
          subjects: $subjects
          delete: $deleted
        ) {
          id
        }
      }
    `,
    // The empty function supplied for the onError callback is designed to
    // resolve the error itself returned from the onSubmit Promise. This allows
    // us to pass errors out to components as props but to ensure that the
    // Promise can resolve successfully first.
    // For more information: https://stackoverflow.com/a/59472340
    {
      onError: () => {},
      refetchQueries: [
        {
          query: CASE_LIST,
          variables: {
            facilityId: props.facilityId,
            archived: true,
          },
        },
        {
          query: CASE_LIST,
          variables: {
            facilityId: props.facilityId,
            archived: false,
          },
        },
      ],
      awaitRefetchQueries: true,
    }
  )

  const onDelete = ({ id, type, facilityId, subjects, deleted }) => {
    deleteCase({
      variables: {
        id,
        type,
        facilityId,
        subjects,
        deleted,
      },
    })
  }

  if (error) throw error

  return { onDelete, deleteLoading: loading }
})
